import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import DatePicker from "react-multi-date-picker"
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian_en from "react-date-object/locales/gregorian_en"
import { fetchCompaniesList } from '../../../redux/action/companies/companies';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator'
import { fetchManagerMessage } from '../../../redux/action/managerMessages/createManagerMessage';
import './style.scss'
import { MultiSelect } from "react-multi-select-component";
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const SendMessage = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [sendMessage, setSendMessage] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [selected, setSelected] = useState([]);
    const [selectData, setSelectData] = useState([])
    const [startDate, setStartDate] = useState('')
    const dispatch = useDispatch()
    const companies = useSelector(state => state.companies_page)
    const manager_message = useSelector(state => state.manager_message)
    const {t} = useTranslation();
    const [data, setData] = useState({
      title: '',
      description: '',
      send_time: '',
      to: ''
    })
  
    const changeHandler = event => {
      setData({ ...data, [event.target.name]: event.target.value })
    }

    const setSelectHandler = (e) => {
      var allChosed = e.find(value => value.value === "all")
      setSelected(e)
    }

    const handleShowBox = () => {
      setSendMessage(true)
      window.scrollTo(0, 200)
    }
  
    const validator = useRef(new SimpleReactValidator({
      messages: {
        required:"پر کردن این فیلد الزامی است"
      },
    }))

    useEffect(() => {
      if(!companies.companies_page.length) {
        dispatch(fetchCompaniesList())
      }
    }, [])
    
    useEffect(() => {
      companies.companies_page.length &&
        companies.companies_page.unshift({id: 'all', title: 'همه غرفه‌ها'})
      companies.companies_page.length &&
        setSelectData(companies.companies_page.map(({ title, id }) => ({ value: id, label: title })))
    }, [companies.companies_page])
    
    useEffect(() => {
      if(manager_message.manager_message) {
        manager_message.manager_message.success === true &&
        setData({
          title: '',
          description: '',
          send_time: '',
          to: ''
        })
        setSelected([])
        setStartDate('')
        window.scrollTo(0, 0)
      }
    }, [manager_message.manager_message])

    function startDateHandler(startDate){
      setStartDate(startDate)
      const stDate = startDate.convert(gregorian, gregorian_en).format("YYYY-MM-DD HH:mm:ss")
      setData({
        ...data,
        send_time: stDate
      })
    }
    
    const handleFormSubmit = (e) => {
      e.preventDefault()
      setBtnLoading(true)
      if (validator.current.allValid()) {
        setBtnLoading(false)
        let message = {
          title: data.title,
          description: data.description,
          send_time: data.send_time,
          to: selected.map(item => item.value)
        }
        dispatch(fetchManagerMessage(message))
        props.update()
      } else {
        setBtnLoading(false)
        setForceUpdate(1)
        validator.current.showMessages()
        toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right'})
      }
    }


  return (
    <div>
        <div className="col-12 create_btn my-5 d-flex justify-content-end">
            <button className="btn btn-success" onClick={handleShowBox}> {t("create new ticket")} <i className="fa fa-plus"></i></button>
        </div>
        {sendMessage &&
            <Form className='col-lg-6' onSubmit={handleFormSubmit}>
                <Form.Group className="mb-3" controlId="messageTo">
                <Form.Label>{t("send to")} :</Form.Label>
                <MultiSelect
                    hasSelectAll={false}
                    options={selectData}
                    value={selected}
                    onChange={setSelectHandler}
                    labelledBy="Select"
                    disableSearch="true"
                    position="top"
                />
                <span className='validator_error'>{validator.current.message('selected', selected, 'required')}</span>
                </Form.Group>
                <Form.Group className="mb-3" controlId="messageTitle">
                <Form.Label>{t("title")} :</Form.Label>
                <Form.Control type="text" name="title" value={data.title} onChange={changeHandler} />
                <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                </Form.Group>
                <Form.Group className="mb-3" controlId="messageDescription">
                <Form.Label>{t("message")} :</Form.Label>
                <Form.Control as="textarea" name="description" value={data.description} onChange={changeHandler} rows={3} />
                <span className='validator_error'>{validator.current.message('description', data.description, 'required')}</span>
                </Form.Group>
                <Form.Group className="mb-3" controlId="messageDate">
                <Form.Label>{t("date")} :</Form.Label>
                <div style={{ direction: "rtl" }} className="datepicker form-control">
                    <DatePicker 
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="top-right"
                    value={startDate}
                    onChange={startDateHandler}
                    format='YYYY-MM-DD HH:mm:ss'
                    name="send_time"
                    plugins={[
                        <TimePicker position="bottom" />
                    ]} 
                    />
                </div>
                </Form.Group>
                <span className='validator_error'>{validator.current.message('send_time', data.send_time, 'required')}</span>
                <Button variant="primary" type="submit" className='mt-3 px-3' disabled={btnLoading ? true : false}>
                  {t("send")}
                </Button>
            </Form>
        }
    </div>
  )
}

export default SendMessage;
